module.exports = __webpack_public_path__ + "img/icon-social-group-24-px.42cd93db.svg";